import { render } from "./configListEdit.vue?vue&type=template&id=f36f6024&scoped=true"
import script from "./configListEdit.vue?vue&type=script&lang=js"
export * from "./configListEdit.vue?vue&type=script&lang=js"

import "./configListEdit.vue?vue&type=style&index=0&id=f36f6024&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36f6024"]])

export default __exports__